import React from 'react'
import { useFormContext, useWatch } from 'react-hook-form'
import { useTranslation } from 'react-i18next'
import { Segment } from 'semantic-ui-react'
import { FormFields } from '~/components/FormFields'
import AssetFileUpload from './AssetFileUpload'
import WYSIWYGEditor from '~/components/WYSWYGEditor'
import { StyledTabPane } from '../style'
import { AssetUpload } from './style'

interface LanguageTabProps {
  index: number
  languageId: string
  activeIndex: number
  removeUpload?: boolean
}

const LanguageTab: React.FC<LanguageTabProps> = (props) => {
  const { t } = useTranslation()
  const {
    getValues,
    control,
    setValue,
    clearErrors
  } = useFormContext()

  const {
    index,
    languageId,
    activeIndex,
    removeUpload
  } = props

  const stripHtml = (html: string) => {
    const div = document.createElement('div')
    div.innerHTML = html
    return div.textContent || div.innerText || ''
  }

  const fileFieldName = `languages[${index}].file`

  const watchHeaderTextField = useWatch({ control, name: `languages[${index}].headerText` })
  const watchFileField = useWatch({ control, name: fileFieldName })

  const isHeaderTextEmpty = !stripHtml(watchHeaderTextField).trim()
  const isFileEmpty = !watchFileField

  return <StyledTabPane key={languageId}>
    <Segment>
      <AssetUpload.LangRow>
        <AssetUpload.LangFieldsCol>
          <FormFields.Input
            control={control}
            name={`languages[${index}].title`}
            label={t('Title')}
            placeholder={t('Title')}
            rules={{
              required: t('Please enter title'),
              maxLength: {
                value: 100,
                message: t('Max. 100 characters allowed')
              }
            }}
          />
          <FormFields.External
            name={`languages[${index}].headerText`}
            label={t('File Description')}
            control={control}
            onChange={(value) => {
              setValue(`languages[${index}].headerText`, value)
              if (stripHtml(value).trim()) {
                clearErrors(fileFieldName)
                clearErrors(`languages[${index}].headerText`)
              }
            }}
            rules={{
              required: isFileEmpty ? t('Please enter description') : false
            }}
            tag='textarea'
          >
            <WYSIWYGEditor key={'1'} maxLength={1000} />
          </FormFields.External>
          <FormFields.External
            name={`languages[${index}].footerText`}
            label={t('Footer description')}
            control={control}
            tag='textarea'
          >
            <WYSIWYGEditor key={'2'} maxLength={1000} />
          </FormFields.External>
          {!removeUpload && <FormFields.Checkbox
            control={control}
            label={t('Can file be downloaded?')}
            defaultValue={0}
            checkboxValue={1}
            name={'downloadEnabled'}
          />}
        </AssetUpload.LangFieldsCol>
        {!removeUpload && <AssetUpload.LangUploadCol>
          <FormFields.External
            control={control}
            label={t('File')}
            keyName={getValues(`languages[${index}]`)}
            onChange={(file: File) => {
              setValue(`languages[${index}].file`, file)
              if (file) {
                clearErrors(`languages[${index}].headerText`)
                clearErrors(fileFieldName)
              }
            }}
            id={getValues('id') || `languages[${index}].file`}
            name={fileFieldName}
            rules={{
              required: isHeaderTextEmpty ? t('Please upload file') : false
            }}
          >
            <AssetFileUpload
              activeTabIndex={activeIndex}
              sizeLimitInMB={300}
              accept={['.pdf', '.doc', '.docx', '.txt', '.csv', '.xls', '.xlsx', '.png', '.jpeg', '.jpg', '.bmp', '.mp4']} />
          </FormFields.External>
        </AssetUpload.LangUploadCol>}
      </AssetUpload.LangRow>
    </Segment>
  </StyledTabPane>
}
export default LanguageTab
